export default __webpack_public_path__ + "static/media/electric4.117aa5cb.jpg";